class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      try {
        const el = document.getElementById(section.id);
        const html = parsedState.sections && parsedState.sections[section.id];
        if (!el || !html) return;
        if (section.id === 'cart-icon-bubble') return;
        el.innerHTML = this.getSectionInnerHTML(html, section.selector);
      } catch (error) {
        console.error(error);
      }
    });

    this.fillProductFallback(parsedState);
    this.refreshCartCount();
    if (this.header) this.header.reveal();
    this.open();
  }

  fillProductFallback(parsedState) {
    const box = document.getElementById('cart-notification-product');
    if (!box || box.textContent.trim()) return;
    const name = parsedState.product_title || parsedState.title || 'This item';
    const line = document.createElement('p');
    line.className = 'cart-notification-product__name h4';
    line.style.margin = '0';
    line.textContent = name;
    box.appendChild(line);
  }

  refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        let count = bubble.querySelector('.cart-count-bubble');
        if (!cart.item_count) {
          if (count) count.remove();
          return;
        }
        if (!count) {
          count = document.createElement('div');
          count.className = 'cart-count-bubble';
          const shown = document.createElement('span');
          shown.setAttribute('aria-hidden', 'true');
          const hidden = document.createElement('span');
          hidden.className = 'visually-hidden';
          count.append(shown, hidden);
          bubble.appendChild(count);
        }
        const shown = count.querySelector('[aria-hidden="true"]');
        const hidden = count.querySelector('.visually-hidden');
        if (shown) shown.textContent = cart.item_count < 100 ? String(cart.item_count) : '';
        if (hidden) hidden.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
      })
      .catch(() => {});
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;
    if (form.closest('product-form') || form.classList.contains('installment')) return;
    event.preventDefault();
    event.stopPropagation();

    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    const body = new FormData(form);
    const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      body.append(
        'sections',
        cartEl.getSectionsToRender().map((section) => section.id)
      );
      body.append('sections_url', window.location.pathname);
      if (typeof cartEl.setActiveElement === 'function') cartEl.setActiveElement(document.activeElement);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          const message = response.description || response.message || 'Could not add this item.';
          let note = form.parentElement && form.parentElement.querySelector('.solara-added-note');
          if (!note) {
            note = document.createElement('p');
            note.className = 'solara-added-note';
            form.insertAdjacentElement('afterend', note);
          }
          note.textContent = message;
          return;
        }
        if (cartEl && typeof cartEl.renderContents === 'function') {
          cartEl.renderContents(response);
          return;
        }
        let note = form.parentElement && form.parentElement.querySelector('.solara-added-note');
        if (!note) {
          note = document.createElement('p');
          note.className = 'solara-added-note';
          note.style.margin = '8px 0 0';
          form.insertAdjacentElement('afterend', note);
        }
        const name = response.product_title || response.title || 'This item';
        note.replaceChildren();
        note.append(document.createTextNode(name + ' added. '));
        const link = document.createElement('a');
        link.href = '/cart';
        link.textContent = 'View cart';
        note.append(link);
      })
      .catch(() => {})
      .finally(() => {
        if (button) button.disabled = false;
      });
  },
  true
);
